import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TaskNotificationService } from '../../core/services/task-notification.service';

@Component({
  selector: 'app-task-notifications',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="task-stack" *ngIf="taskNotificationService.tasks().length > 0">
      <div class="task-card" *ngFor="let task of taskNotificationService.tasks()" [class.is-success]="task.status === 'success'" [class.is-error]="task.status === 'error'">
        <div class="task-icon">
          <div *ngIf="task.status === 'running'" class="spinner" aria-hidden="true"></div>
          <mat-icon *ngIf="task.status === 'success'">check_circle</mat-icon>
          <mat-icon *ngIf="task.status === 'error'">error</mat-icon>
        </div>
        <div class="task-copy">
          <div class="task-title">{{ task.title }}</div>
          <div class="task-message">{{ task.message }}</div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .task-stack {
      position: fixed;
      left: 1rem;
      bottom: 1rem;
      z-index: 1200;
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      pointer-events: none;
    }
    .task-card {
      display: flex;
      align-items: center;
      gap: 0.85rem;
      width: min(360px, calc(100vw - 2rem));
      padding: 0.9rem 1rem;
      border-radius: 14px;
      background: rgba(15, 23, 42, 0.96);
      color: #f8fafc;
      box-shadow: 0 20px 50px rgba(15, 23, 42, 0.28);
      border: 1px solid rgba(148, 163, 184, 0.16);
      backdrop-filter: blur(8px);
    }
    .task-card.is-success {
      background: rgba(22, 101, 52, 0.96);
      border-color: rgba(134, 239, 172, 0.28);
    }
    .task-card.is-error {
      background: rgba(153, 27, 27, 0.96);
      border-color: rgba(252, 165, 165, 0.28);
    }
    .task-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.12);
      flex: 0 0 auto;
    }
    .task-copy {
      min-width: 0;
    }
    .task-title {
      font-size: 0.95rem;
      font-weight: 700;
      line-height: 1.2;
    }
    .task-message {
      margin-top: 0.2rem;
      font-size: 0.87rem;
      opacity: 0.92;
      line-height: 1.35;
    }
    .spin {
      animation: task-spin 1s linear infinite;
    }
    .spinner {
      width: 1.15rem;
      height: 1.15rem;
      border-radius: 999px;
      border: 2px solid rgba(255, 255, 255, 0.3);
      border-top-color: #ffffff;
      animation: task-spin 0.9s linear infinite;
    }
    @keyframes task-spin {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    @media (max-width: 768px) {
      .task-stack {
        left: 0.75rem;
        right: 0.75rem;
        bottom: 0.75rem;
      }
      .task-card {
        width: auto;
      }
    }
  `]
})
export class TaskNotificationsComponent {
  taskNotificationService = inject(TaskNotificationService);
}
